<template>
    <div class="afil-legend">
        <ul>
            <li @click="toggleLegendRelations('edges.3')">
                <div class="legend__line-through" v-if="!legend.edges[3]"></div>
                <div class="afil-legend-edge afil-legend-edge__upr">
                    <div class="afil-legend-edge__text"></div>
                </div>
                <div>Рук-ль, УК</div>
            </li>
            <li @click="toggleLegendRelations('edges.4')">
                <div class="legend__line-through" v-if="!legend.edges[4]"></div>
                <div class="afil-legend-edge afil-legend-edge__lupr">
                    <div class="afil-legend-edge__text"></div>
                </div>
                <div>Быв. руководитель</div>
            </li>
            <li @click="toggleLegendRelations('edges.5')">
                <div class="legend__line-through" v-if="!legend.edges[5]"></div>
                <div class="afil-legend-edge afil-legend-edge__uchr">
                    <div class="afil-legend-edge__text">100%</div>
                </div>
                <div>Собственник</div>
            </li>
            <li @click="toggleLegendRelations('edges.6')">
                <div class="legend__line-through" v-if="!legend.edges[6]"></div>
                <div class="afil-legend-edge afil-legend-edge__luchr">
                    <div class="afil-legend-edge__text">(бывший)</div>
                </div>
                <div>Собственник (быв.)</div>
            </li>
            <li @click="toggleLegendRelations('edges.21')">
                <div class="legend__line-through" v-if="!legend.edges[21]"></div>
                <div class="afil-legend-edge afil-legend-edge__predsh">
                    <div class="afil-legend-edge__text">Предш</div>
                </div>
                <div>Предшественник</div>
            </li>
        </ul>
        <ul>
            <li @click="toggleLegendRelations('nodes.1')">
                <div class="legend__line-through" v-if="!legend.nodes[1]"></div>
                <i class="fa fa-building"></i>
                Юридическое лицо
            </li>
            <li @click="toggleLegendRelations('nodes.2')">
                <div class="legend__line-through" v-if="!legend.nodes[2]"></div>
                <i class="fa fa-user"></i>
                Индивидуальный предприниматель
            </li>
            <li @click="toggleLegendRelations('nodes.3')">
                <div class="legend__line-through" v-if="!legend.nodes[3]"></div>
                <i class="fa fa-globe"></i>
                Иностранное юридическое лицо
            </li>
            <li @click="toggleLegendRelations('nodes.4')">
                <div class="legend__line-through" v-if="!legend.nodes[4]"></div>
                <i class="fa fa-university"></i>
                Субъект РФ, ПИФ
            </li>
            <li @click="toggleLegendRelations('nodes.5')">
                <div class="legend__line-through" v-if="!legend.nodes[5]"></div>
                <i class="fa fa-male"></i>
                Физическое лицо
            </li>
            <li @click="toggleLegendRelations('status.1')">
                <div class="legend__line-through" v-if="!legend.status[1]"></div>
                <div class="status-color-block status-color-block__green"></div>
                Действущее
            </li>
            <li @click="toggleLegendRelations('status.2')">
                <div class="legend__line-through" v-if="!legend.status[2]"></div>
                <div class="status-color-block status-color-block__red"></div>
                Ликвидированое
            </li>
            <li @click="toggleLegendRelations('status.3')">
                <div class="legend__line-through" v-if="!legend.status[3]"></div>
                <div class="status-color-block status-color-block__orange"></div>
                В стадии ликвидации
            </li>
            <li @click="toggleLegendRelations('status.4')">
                <div class="legend__line-through" v-if="!legend.status[4]"></div>
                <div class="status-color-block status-color-block__orange"></div>
                В стадии реорганизации
            </li>
        </ul>
    </div>
</template>

<script>
export default {
    props: {
        legend: Object,
        toggleLegendRelations: Function
    }
}
</script>

<style lang="sass" scoped>
.afil-legend .legend__line-through
    position: absolute
    width: 95%
    height: 3px
    background-color: #888
    top: 14px
    z-index: 12

.afil-legend .afil-legend-edge
    width: 90px
    margin-right: 10px
    display: inline-block
    vertical-align: middle
    border-top-width: 3px
    border-color: #ccc
    border-style: solid
    position: relative

.afil-legend .afil-legend-edge__text
    position: absolute
    left: 0
    top: -14px
    font-size: 10px
    width: 100%
    text-align: center

.afil-legend .afil-legend-edge__upr
    border-color: #2d82ba

.afil-legend .afil-legend-edge__lupr
    border-color: #2d82ba
    border-style: dashed

.afil-legend .afil-legend-edge__luchr,
.afil-legend .afil-legend-edge__predsh,
.afil-legend .afil-legend-edge__preem
    border-style: dashed

.afil-legend .status-color-block
    width: 22px
    height: 14px
    margin-right: 3px
    display: inline-block
    position: relative
    top: 2px

.afil-legend .status-color-block__green
    background-color: #32cd74

.afil-legend .status-color-block__orange
    background-color: #e78640

.afil-legend .status-color-block__red
    background-color: #e85749

.afil-legend .fa
    font-family: "FontAwesome"
    display: inline-block
    width: 25px
    text-align: center
    font-weight: normal
    color: #9b9b9b
    font-size: 22px
    position: relative
    top: 2px

.afil-legend
    font-size: 0
    position: absolute
    right: 0
    bottom: 0
    background-color: #fff
    border-radius: 5px
    box-shadow: 0 0 3px gray
    padding: 10px
    z-index: 1

.afil-legend ul
    font-size: 12px
    display: inline-block
    vertical-align: top
    padding: 0
    margin: 0
    width: 50%

.afil-legend > ul > li::selection,
.afil-legend > ul > li div::selection
    background-color: transparent
    color: #333

.afil-legend > ul > li
    cursor: pointer
    line-height: 26px
    padding: 2px 5px
    position: relative

.afil-legend > ul > li > div
    display: inline-block

.afil-legend > ul > li:hover
    background-color: rgba(0,0,0,0.1)
</style>